export function roundNumberDecimals(value: number): number {
    return Math.round(value * 100) / 100
}

export function roundNumberToRoundedNumberToQuarter(value: number): number {
    return Math.round(value * 4) / 4
}
